import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/common";
import { ChatBox } from "@/components/ChatBox";

export default function Support() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const load = () => api.get("/support/messages").then((r) => setMsgs(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, []);
  const send = async (text, image_url) => { await api.post("/support/messages", { text, image_url }); await load(); };
  return (
    <Section title="Atención al cliente" subtitle="Chat directo con el equipo de administración. Puedes adjuntar capturas.">
      <ChatBox messages={msgs} onSend={send} meId={user.id} testId="support-chat" placeholder="¿En qué podemos ayudarte?" />
    </Section>
  );
}
